export const SliderData = [
  {
    image:"https://res.cloudinary.com/dsjsbp6qy/image/upload/v1675460563/Dshop/Remodels_Repairs_Maintenance_pvbovx.png"
  },
  {
    image:"https://res.cloudinary.com/dsjsbp6qy/image/upload/v1675370125/Dshop/Alquiler_de_equipos_para_construccion_si9moa.png"
  },
  {
    image:"https://res.cloudinary.com/dsjsbp6qy/image/upload/v1675370124/Dshop/Alquiler_de_equipos_para_construccion_1_nwjbs0.png"
  },
  {
    image:"https://res.cloudinary.com/dsjsbp6qy/image/upload/v1675370124/Dshop/Alquiler_de_equipos_para_construccion_2_pudpym.png"
  },
]